<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.payout_details')" class="diglog-card" :visible.sync="dialogTableVisible" width="580px" @open="getDetailInfo">
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num color-main-linear-blue"> {{ $store.getters.currency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num color-main-linear-blue">{{ $store.getters.currency }} {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title mb-12 mt-12">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-gray"> {{ merchantInfo.transaction_create_time }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_completed') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title mb-12 mt-36">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remitting_bank') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remittance_account') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_account |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_name |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_channel }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_account') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div> -->

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div> -->

      <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" min-width="150" class="tag-custom payout-status"> {{ getPOTransactionStatusLabel(merchantInfo.po_trans_status,merchantInfo.refund_type) }}</el-tag>
      <div class="btn-container">
        <el-button v-if="[3,4].indexOf(merchantInfo.po_trans_status) !== -1" class="btn-retry btn" :disabled="merchantInfo.refund_type === 2" type="primary" plain @click="retryNotice">
          {{ $t('data.resend_notice') }}
        </el-button>
        <el-button class="btn-download" type="info" @click="onClickDownload">
          {{ $t('components.download') }}
        </el-button>
      </div>
      <DetailDownload ref="detailDownload" :merchant-info="merchantInfo" />
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayoutDetail, disburseNotice } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'
import DetailDownload from '../PayoutDetailDownload.vue'
export default {
  name: 'Po_Details_Modal',
  components: {
    DetailDownload
  },
  props: {
    detailId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, disbursement_fee: {}}
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    getPOTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      this.merchantInfo = {}
      fetchPayoutDetail({ transaction_id: this.detailId }).then(res => {
        this.merchantInfo = res.data || {}
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },
    onClickDownload() {
      this.$refs.detailDownload.saveImg()
    },
    retryNotice() {
      this.$confirm('Did you want to re-try notice?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          transaction_id: this.detailId
        }
        disburseNotice(params).then(res => {
          this.$message.success('Success')
        })
      })
    }
  }
}
</script>

<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 160px;
  }
}
</style>
